import { useIntl } from "react-intl";
export const reportMessages = {
  en: {
    protocolTitle: "Action protocol",
    protocolLegend: "Symbols",
    protocolInstall: "Placement",
    protocolCheck: "Check",
    protocolReplace: "Replacement",
    protocolRemove: "Removal",
    protocolHook: "Hook",
    protocolButton: "Button",
    protocolBiteRamp: "Bite ramp",
    protocolTorque: "Torque controller",
    protocolIpr: "Perform IPR",
    protocolToothAction: "Tooth {tooth}: {action}",
    protocolSeparation: "IPR {pair}: {amount} mm",
    protocolStage: "Stage {step}",
    protocolVerified: "Checked by:",
    protocolName: "Name:",
    protocolDate: "Date:",
    protocolPrintError: "Protocol images could not be prepared for printing. Try again.",
    reportSelectLocalPlan: "Open a converted local plan to view its report.",
    reportTitle: "Treatment plan report",
    reportPrint: "Print",
    reportBack: "Back to patient",
    reportNavigation: "Report navigation",
    reportLocalPlan: "Local plan: {id}",
    reportLoading: "Loading report…",
    reportLoadError: "The report could not be loaded. Check that the plan is available and try again.",
    reportRetry: "Try again",
    reportProtocolMissing: "The published package has incomplete action protocol data. Printing is disabled. The server could not prepare this section of the report; contact support.",
    reportPatientId: "Patient ID",
    reportPublishedPlanId: "Plan ID",
    reportPatientName: "Patient name",
    reportUpper: "Upper arch",
    reportLower: "Lower arch",
    reportStepCount: "Number of stages",
    reportIprSteps: "IPR before stage",
    reportAttachSteps: "Attachments before stage",
    reportDetachSteps: "Remove attachments before stage",
    reportInitial: "Before treatment",
    reportSuperimposed: "Superimposition",
    reportFinal: "Final position",
    reportImages: "Treatment comparison",
    reportPreviousImage: "Previous view",
    reportNextImage: "Next view",
    reportImagesMissing: "Report images are not available for this version or could not be loaded. Refresh the page; if this repeats, contact support.",
    reportMovementTitle: "Movement information",
    reportMovement: "Movement",
    reportContactPhone: "Phone: +7 (495) 211-44-54",
    reportLegalInfo: "Legal information",
    reportLegalAnd: " and ",
    reportPaymentDetails: "3D-Smile.ru company details",
    reportTip: "Tip",
    reportRotation: "Rotation",
    reportTorque: "Torque",
    reportBuccalLingual: "Buccal/Lingual",
    reportExtrusionIntrusion: "Extrusion/Intrusion",
    reportMesialDistal: "Mesial/Distal",
    reportMm: "mm",
    reportLimit: "Limit: {value} {unit}",
    reportExceeded: "Limit exceeded",
    reportMovementsMissing: "{arch}: movement data is unavailable. Empty cells are shown as dashes.",
    reportDoctorName: "Treating doctor",
    reportDoctorId: "Doctor ID",
    reportContextMissing: "Open the report from the patient page.",
  },
  ru: {
    protocolTitle: "Протокол действий",
    protocolLegend: "Обозначения",
    protocolInstall: "Установка",
    protocolCheck: "Проверка",
    protocolReplace: "Замена",
    protocolRemove: "Удаление",
    protocolHook: "Крючок",
    protocolButton: "Кнопка",
    protocolBiteRamp: "Накусочная площадка",
    protocolTorque: "Контроллер торка",
    protocolIpr: "Произвести сепарацию",
    protocolToothAction: "Зуб {tooth}: {action}",
    protocolSeparation: "Сепарация {pair}: {amount} мм",
    protocolStage: "Этап {step}",
    protocolVerified: "Проверка произведена:",
    protocolName: "Имя:",
    protocolDate: "Дата:",
    protocolPrintError: "Не удалось подготовить изображения протокола к печати. Повторите попытку.",
    reportSelectLocalPlan: "Для отчёта откройте сконвертированный локальный план.",
    reportTitle: "Отчёт по плану лечения",
    reportPrint: "Распечатать",
    reportBack: "Вернуться к пациенту",
    reportNavigation: "Навигация отчёта",
    reportLocalPlan: "Локальный план: {id}",
    reportLoading: "Загрузка отчёта…",
    reportLoadError: "Не удалось загрузить отчёт. Проверьте доступность плана и попробуйте ещё раз.",
    reportRetry: "Повторить",
    reportProtocolMissing: "В опубликованном пакете неполные данные протокола действий. Печать отключена. Сервер не смог подготовить этот раздел отчёта; обратитесь в поддержку.",
    reportPatientId: "ID пациента",
    reportPublishedPlanId: "ID плана",
    reportPatientName: "ФИО",
    reportUpper: "Верхняя челюсть",
    reportLower: "Нижняя челюсть",
    reportStepCount: "Число этапов",
    reportIprSteps: "Сепарация перед этапом",
    reportAttachSteps: "Замки перед этапом",
    reportDetachSteps: "Удалить замки перед этапом",
    reportInitial: "До лечения",
    reportSuperimposed: "Суперимпозиция",
    reportFinal: "Финальное положение",
    reportImages: "Сравнение положений зубов",
    reportPreviousImage: "Предыдущий вид",
    reportNextImage: "Следующий вид",
    reportImagesMissing: "Изображения отчёта для этой версии недоступны или не загрузились. Обновите страницу; если сообщение повторяется, обратитесь в поддержку.",
    reportMovementTitle: "Информация о перемещении",
    reportMovement: "Перемещение",
    reportContactPhone: "Телефон для связи: +7 (495) 211-44-54",
    reportLegalInfo: "Юридическая информация",
    reportLegalAnd: " и ",
    reportPaymentDetails: "Реквизиты 3D-Smile.ru",
    reportTip: "Ангуляция",
    reportRotation: "Ротация",
    reportTorque: "Торк",
    reportBuccalLingual: "Наружу/внутрь",
    reportExtrusionIntrusion: "Экструзия/интрузия",
    reportMesialDistal: "Мезиально/дистально",
    reportMm: "мм",
    reportLimit: "Предел: {value} {unit}",
    reportExceeded: "Предел превышен",
    reportMovementsMissing: "{arch}: данные о перемещениях недоступны. Пустые значения показаны прочерками.",
    reportDoctorName: "Лечащий врач",
    reportDoctorId: "ID врача",
    reportContextMissing: "Откройте отчёт из карточки пациента.",
  },
} as const;
export type MessageKey = keyof typeof reportMessages.ru;
export function useI18n() {
  const intl = useIntl();
  return { t: (key: MessageKey, values?: Record<string, string | number>) => intl.formatMessage({ id: key }, values) };
}
